module.exports = __webpack_public_path__ + "static/media/I_must_obey_the_hypno_virus.216d28b3.mp3";